import { useHoaDonMuaDichVuMutation } from './useHoaDonMuaDichVuMutation';
import { useHoaDonMuaDichVuTable } from './useHoaDonMuaDichVuTable';
import { useHoaDonMuaDichVuSearchContext } from './search-context';

export const useHoaDonMuaDichVuPage = () => {
  const { transactionOptions, isExporting } = useHoaDonMuaDichVuSearchContext();
  const tableState = useHoaDonMuaDichVuTable();
  const mutationState = useHoaDonMuaDichVuMutation({ tableState });

  return {
    searchDialog: tableState.searchDialog,
    formDialog: {
      open: tableState.dialogs.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.dialogs.isCopyMode,
      detail: tableState.crud.detail,
      onClose: tableState.form.handleCloseForm,
      onSubmit: mutationState.handleSubmit,
      onAdd: tableState.form.handleAddClick,
      onEdit: mutationState.handleEditClick,
      onDelete: tableState.form.handleDeleteClick,
      onCopy: tableState.form.handleCopyClick
    },
    deleteDialog: {
      open: tableState.dialogs.showDelete,
      onClose: tableState.form.handleCloseDelete,
      onConfirm: mutationState.handleDelete
    },
    bulkDeleteDialog: {
      open: tableState.dialogs.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: mutationState.handleBulkDelete
    },
    table: tableState.table,
    detailTable: {
      rows: tableState.crud.detail?.chi_tiet_data || []
    },
    actions: {
      isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: mutationState.handleEditClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleRowClick: tableState.form.handleRowClick,
      handleRefresh: tableState.table.onRefresh,
      handleSearch: tableState.searchDialog.onOpen
    },
    selection: {
      selectedObj: tableState.selection.selectedObj,
      selectedRowIndex: tableState.selection.selectedRowIndex
    }
  };
};
